import * as Types from '../constants/Types';

export const getSupplierCategoryListAll = () => ({ type: Types.SUPPLIER_CATEGORY_LIST_ALL_ACTION });
export const setSupplierCategoryListAll = (data) => ({ type: Types.SUPPLIER_CATEGORY_LIST_ALL_SUCCESS, ...data });

export const getSupplierCategoryList = (params) => ({ type: Types.SUPPLIER_CATEGORY_LIST_ACTION, params });
export const setSupplierCategoryList = (data) => ({ type: Types.SUPPLIER_CATEGORY_LIST_SUCCESS, ...data });

export const getSupplierCategoryDetail = (id) => ({ type: Types.SUPPLIER_CATEGORY_GET_DETAIL_ACTION, id });
export const setSupplierCategoryDetail = (category) => ({ type: Types.SUPPLIER_CATEGORY_GET_DETAIL_SUCCESS, category });

export const createSupplierCategoryAction = (category) => ({ type: Types.SUPPLIER_CATEGORY_CREATE_ACTION, category });
export const updateSupplierCategoryAction = (category) => ({ type: Types.SUPPLIER_CATEGORY_UPDATE_ACTION, category });
export const deleteSupplierCategoryAction = (category, refreshParams) => ({ type: Types.SUPPLIER_CATEGORY_DELETE_ACTION, category, refreshParams });